// @ts-strict

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationsService } from '@app/core/services/notifications/notifications.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MinimizeMaximizeConversationsService } from '@services/minimize-maximize-conversations/minimize-maximize-conversations.service';
import { PrivateChatService } from '@services/private-chat/private-chat.service';

export type PanelHeaderItem = { name: string; results?: any[] };
@Component({
  selector: 'app-panel-header',
  templateUrl: './panel-header.component.html',
  styleUrls: ['./panel-header.component.scss']
})
export class PanelHeaderComponent {
  @Input() data?: PanelHeaderItem[];
  @Input() component?: string;
  @Input() activeItem?: string;
  @Input() isLoaded?: boolean;
  @Input() icon?: string;
  @Input() title?: string;
  @Input() isHeaderCollapsed = false;

  @Output() emitItem: EventEmitter<string> = new EventEmitter();

  public newConversation = false;

  constructor(
    public activeModal: NgbActiveModal,
    private conversastionsViewService: MinimizeMaximizeConversationsService,
    public notificationsService: NotificationsService,
    public privateChat: PrivateChatService
  ) {}

  public getClickedItem(item: string): void {
    this.emitItem.emit(item);
  }

  public close(): void {
    this.activeModal.close();
    if (this.title === 'conversations') {
      this.conversastionsViewService.close();
    }
  }
}
